export default __webpack_public_path__ + "static/media/ownership.b24500ca.png";